import axios from 'axios';
import router from '../../router';
import socket from '../../services/socket';
import notificator from '../../services/notificator';

export default {
  namespaced: true,
  state: {
    games: [],
    totalGames: -1,
  },
  getters: {
    getGames: (state) => state.games,
    getTotalGames: (state) => state.totalGames,
  },
  mutations: {
    setGames: (state, games) => (state.games = games),
    setTotalGames: (state, totalGames) => (state.totalGames = totalGames),
  },
  actions: {
    createGame: async (ctx, isPrivate) => {
      try {
        const { data } = await axios.post('/lobby/create', {
          private: isPrivate,
        });

        router.push({ name: 'game', params: { id: data.gameId } });
      } catch (e) {
        console.log({ ...e });

        notificator.error('The game could not be created.');
      }
    },
    joinGameByPinCode: async ({ commit }, pinCode) => {
      try {
        const { data } = await axios({
          method: 'get',
          url: `/lobby/${pinCode}`,
        });

        router.push({ name: 'game', params: { id: data.gameId } });
      } catch (e) {
        console.log({ ...e });

        notificator.error('Could not join the game.');
      }
    },
    sitDown: async ({ commit }, gameId) => {
      try {
        await axios({ method: 'link', url: `/lobby/${gameId}` });

        socket.emitFetchState(gameId);
      } catch (e) {}
    },
    standUp: async ({ commit }, gameId) => {
      try {
        await axios({ method: 'unlink', url: `/lobby/${gameId}` });

        socket.emitFetchState(gameId);
      } catch (e) {}
    },
    leaveRoom: async ({ commit, dispatch, rootGetters }, payload) => {
      if (payload.roomId !== 'lobby') {
        try {
          await dispatch('standUp', payload.roomId);
        } catch (e) {}
      }

      socket.emitLeaveRoom(payload.roomId);
    },
    fetchGames: async ({ commit }) => {
      try {
        const { data } = await axios.get('/lobby/');

        commit('setGames', data.items);
        commit('setTotalGames', data.total);
      } catch (e) {}
    },
  },
};
